const MS_PER_DAY = 24 * 60 * 60 * 1000;

// A partir de acá ya no se cuentan los días: «hace 47 días» no dice más que «hace más de un mes».
const MAX_COUNTED_DAYS = 30;

function localDayNumber(date) {
    return Math.round(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / MS_PER_DAY);
}

/**
 * Cuándo la IA del equipo usó el prompt por última vez, en días de CALENDARIO de quien mira (ayer
 * a las 23:50 es «ayer», aunque hayan pasado diez minutos).
 *
 * Devuelve la clave i18n y, si hace falta, el `count`. `used` dice si hubo algún uso: la fila lo
 * pinta en verde con un punto, y en gris cuando todavía no hubo ninguno.
 */
export function relativeUse(lastUse, now = new Date()) {
    const at = lastUse && lastUse.at ? new Date(lastUse.at) : null;
    if (!at || Number.isNaN(at.getTime())) {
        return {key: 'agency_prompts.used_never', used: false};
    }
    const days = localDayNumber(now) - localDayNumber(at);
    // Un reloj adelantado puede dejar el uso «en el futuro»: se lee como hoy.
    if (days <= 0) return {key: 'agency_prompts.used_today', used: true};
    if (days === 1) return {key: 'agency_prompts.used_yesterday', used: true};
    if (days <= MAX_COUNTED_DAYS) return {key: 'agency_prompts.used_days_ago', count: days, used: true};
    return {key: 'agency_prompts.used_long_ago', used: true};
}
